import Network from '@/common/lib/Network';
import Store from '@/config/store';

export default {

  getPaymentData() {

    let data = {
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      pnbon: Store.getters['panier/get_pnbon'],
      lgue: Store.getters['application/get_application_user'].lang
    };

    return Network.execute('GET', 'get_payment_data', data);
  },

  getPaymentDataOutstanding() {

    let data = {
      pcsoc: Store.getters['application/get_application_company'].PCSOC,
      pnocl: Store.getters['application/get_application_customer'].TNCLI,
      lgue: Store.getters['application/get_application_user'].lang,
      price: Store.getters['encour/get_outstanding_pay'],
      pcdev: Store.getters['application/get_application_customer'].TCDEV,
      ref: Store.getters['encour/get_outstanding_ref']
    };

    return Network.execute('GET', 'get_payment_data_outstanding', data);
  }
}